import React, { useEffect } from "react";
import "react-quill/dist/quill.snow.css";
import "./TrainingCourseView.scss";
import { Row, Col, Image, Statistic, Skeleton, Typography, Card } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import EqButton from "../../../custom/eqButton/EqButton";
import { CalendarOutlined, FieldTimeOutlined, UserOutlined } from "@ant-design/icons";
import useCourseValidation from "./useCourseValidation";
import { getUserIdFromToken } from "../../../shared/Common";
import {
    EqOrderStatus,
    TrainingCourseViewProp,
} from "../../../shared/interfaces/ridingCourse/IRidingCourse";
import { EqCurrency, EqEventRepeatType } from "../../../shared/enums";

const TrainingCourseView: React.FC<TrainingCourseViewProp> = ({
    course,
    isStudent,
    onBuy,
    onPayNow,
}) => {
    const { t } = useTranslation();
    const validateData = useCourseValidation();
    const currentUserId = getUserIdFromToken();

    useEffect(() => {

    }, [course]);

    const { Title, Text } = Typography;

    const getRepeatVal = (): string => {
        var df = moment(course?.startDate);
        // var df2 = moment(course?.startDate/1000);

        console.log("start date: " + course?.startDate)
        return EqEventRepeatType[course?.repeatType?? 2];
    }




    return (
        <div className="riding-course-view">
            {!course ? <div className="loading"><Skeleton loading={!course} active></Skeleton></div>
                :
                <>

                    <div style={{ backgroundColor: '#f9f9f9', padding: '20px' }}>
                        <Row align="middle" gutter={[16, 16]}>
                            {/* Image Section */}
                            <Col xs={24} sm={8} md={6}>
                                <Image
                                    width="100%"
                                    src={course.image?.url}
                                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                                    alt="Banner Image"
                                    preview={true}
                                />
                            </Col>
                            <Col xs={24} sm={16} md={18}>
                                <Title level={3} style={{ marginBottom: '10px' }}>
                                    {course.title}
                                </Title>
                                <Text>
                                    <div dangerouslySetInnerHTML={{ __html: course.description }} />
                                </Text>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ marginTop: "16px", marginBottom: "8px" }}>
                        <Row gutter={8}>
                            <Col span={8}>
                                <Card bordered={false} className="stat-card">
                                    <Statistic title={t("repeats")} value={getRepeatVal()} />
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card bordered={false} className="stat-card">
                                    <Statistic title={t("starting")} value={moment(course.startDate).format("DD MMMM, YYYY")} suffix={<CalendarOutlined />} />
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card bordered={false} className="stat-card">
                                    <Statistic title={t("duration")} value={course.courseLessons[0]?.durationMinutes} suffix={<FieldTimeOutlined />} />
                                </Card>
                            </Col>
                        </Row>
                    </div>

                        <Row gutter={8}>
                            <Col span={8}>
                            <Card bordered={false} className="stat-card">
                                <Statistic title={t("trainer")} value={course.courseTrainer?.firstName +" "+ course.courseTrainer?.lastName} prefix={<UserOutlined />} />
                                </Card>
                            </Col>
                            <Col span={8}>
                            <Card bordered={false} className="stat-card">
                                <Statistic title={t("price")} value={course.coursePrice} suffix={EqCurrency[course?.currency ?? 0]} />
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card bordered={false} className="stat-card">
                                    {/* <Statistic title={t("capacity")} value={course.courseLessonOrders?.length + "/" + course.courseLessons?.length} /> */}
                                    <Statistic title={t("lessons")} value={course.courseLessons?.length} />
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                        <Col>
                       

                        <EqButton
    onClick={() => {
        const currentUserOrder = course?.courseLessonOrders?.find(order => order.studentId === currentUserId);
        if (currentUserOrder) {
            if (currentUserOrder.orderStatus === EqOrderStatus.Accepted) {
                onPayNow?.(currentUserOrder.id); // Call onPayNow with the orderId
            } else {
                // Handle other statuses if needed
                console.log(`Order status is ${currentUserOrder.orderStatus}`);
            }
        } else {
            onBuy?.(); // Call onBuy if no matching order exists
        }
    }}
    disabled={
        (() => {
            const currentUserOrder = course?.courseLessonOrders?.find(order => order.studentId === currentUserId);
            if (!currentUserOrder) {
                return false; // Enable if no lesson order is available against the current user
            }
            return currentUserOrder.orderStatus !== EqOrderStatus.Accepted; // Disable if the order exists but the status is not Accepted
        })()
    }

>
    {
        (() => {
            const currentUserOrder = course?.courseLessonOrders?.find(order => order.studentId === currentUserId);
            if (currentUserOrder) {
                return currentUserOrder.orderStatus === EqOrderStatus.Accepted
                    ? t("payNow")
                    : t(EqOrderStatus[currentUserOrder.orderStatus]);
            }
            return t("request");
        })()
    }
</EqButton>

                   </Col>

                        </Row>

                </>
            }
        </div>
    );
};

export default TrainingCourseView;
